export default __webpack_public_path__ + "static/media/medical-records-icon.94e3b06a.svg";